import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=2557f8fe&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=2557f8fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2557f8fe",
  null
  
)

export default component.exports